import React from 'react';
import styles from './HandbookImageAnimationDarkBackground.module.scss';
import Title from '../../Components/Title/Title';
import Description from '../../Components/Description/Description';
import Button from '../../Components/Button/Button';
import Image from '../../Components/Image/Image';

const MetamorfozaHandbookImgAnimDarkBg = ({ api }) => {
  return (
    <section
      id={api?.id}
      className={`wrapper ${styles.sectionHandbook}`}
      data-aos="fade-up"
      data-aos-duration="500"
      data-aos-easing="ease-in-out"
      data-aos-once="false"
    >
      <div className={`${styles.sectionContainer} ${styles.metamorfozaHanbook}`}>
        <div className={styles.sectionContext}>
          <Title title={api.attributes.title} type="lightTitle person">
            {!!api.attributes?.differentColor ? <span className={styles.addTitle}>{api.attributes.differentColor}</span> : ''}
          </Title>
          <Description api={api} type="lightDesc person" />
          <Button api={api} type="lightButton person" />
        </div>
        <div className={styles.sectionImage}>
          <Image
            animationData={{
              animation: 'zoom-in',
              animationDuration: '500',
              animationEasing: 'easy-in-out',
            }}
            properties={api.attributes}
            type="lightTitle person animationAfter"
          />
        </div>
      </div>
    </section>
  );
};

export default MetamorfozaHandbookImgAnimDarkBg;
